import fileDownload from 'js-file-download'
import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import {
  PaginatedResponse,
  Truckload,
  TruckloadSM,
} from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from 'src/services/skuit/types'

export interface ExportProps {
  fields: string[],
  exportFilters?: ExportFilters,
}
export class Truckloads {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Truckload>> => {
    config.params = { ...config.params }
    const response = await this.api.get('/shipments/truckloads', config)
    return paginatedTransform(Truckload)(response.data)
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Truckload> => {
    const response = await this.api.get(`/shipments/truckloads/${guid}`, config)
    return rawTransform(Truckload)(response.data)
  }

  shippingManifest = async (guid: string, config: CustomAxiosConfig = {}): Promise<TruckloadSM> => {
    const response = await this.api.get(`/shipments/truckloads/${guid}/shipping-manifest`, config)
    return rawTransform(TruckloadSM)(response.data)
  }

  export = async ({ fields }: ExportProps) => {
    const params = { fields: fields.join(',') }
    const response = await this.api.axiosInstance({
      url: '/freight/truckloads/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'truckloads.csv')
  }
}
